import { inject } from 'vue';

export default function useProductEstimatedTime() {
  const trans = inject('translate');

  const deliveryRange = (days) => {
    if (days <= 2) {
      return trans.get('miliboo.common.hours_range', { start: 24, end: 72 });
    }
    if (days <= 6) {
      return trans.get('miliboo.common.days_range', { start: days - 1, end: days + 1 });
    }
    if (days === 7) {
      return `1 ${trans.get('miliboo.common.week')}`;
    }
    if (days <= 13) {
      return trans.get('miliboo.common.weeks_range', { start: 1, end: 2 });
    }
    if (days === 14) {
      return `2 ${trans.get('miliboo.common.weeks')}`;
    }
    if (days <= 20) {
      return trans.get('miliboo.common.weeks_range', { start: 2, end: 3 });
    }
    if (days === 21) {
      return `3 ${trans.get('miliboo.common.weeks')}`;
    }
    if (days <= 89) {
      return trans.get('miliboo.common.weeks_range', { start: Math.ceil(days / 7) - 1, end: Math.ceil(days / 7) });
    }
    if (days % 30 === 0) {
      return `${days / 30} ${trans.get('miliboo.common.months')}`;
    }
    return trans.get('miliboo.common.months_range', { start: Math.ceil(days / 30) - 1, end: Math.ceil(days / 30) });
  };

  return { deliveryRange };
}
